import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UploadService } from '../../services/upload.service';
import { FormUtil } from '../../core/view/form-util';

@Component({
  selector: 'app-imagem',
  templateUrl: './imagem.component.html',
})
export class ImagemComponent implements OnInit {
  
  @Input() imagem:any;

  @Output() imagemChange = new EventEmitter<any>();
  
  constructor(private uploadService:UploadService, private util:FormUtil){
  }

  ngOnInit(){
  }

  aoSelecionarArquivo(event){
    if (event.target.files.length > 0) {
      this.enviarArquivo(event.target.files[0]);
    }
  }

  enviarArquivo(file){
    const formData = new FormData();
    formData.append('file', file);
   
    this.uploadService.upload(formData)
    .subscribe((_imagem) => {
      this.imagem = _imagem;
      this.imagemChange.emit(this.imagem);
    },
    (err) => {
      this.util.view.showMessage("Não foi possível enviar a imagem.");
      console.error(err);
    });
  }

}
